(function () {
	'use strict';

	const OPEN_CLASS = 'custom-select--open';

	const getFocusableOptions = (root) =>
		Array.from(root.querySelectorAll('.custom-select__option:not([disabled])'));

	const closeSelect = (root) => {
		if (!root) {
			return;
		}

		root.classList.remove(OPEN_CLASS);

		const trigger = root.querySelector('.custom-select__trigger');
		if (trigger) {
			trigger.setAttribute('aria-expanded', 'false');
		}
	};

	const closeAllExcept = (exceptRoot) => {
		document.querySelectorAll('[data-custom-select].' + OPEN_CLASS).forEach((root) => {
			if (root !== exceptRoot) {
				closeSelect(root);
			}
		});
	};

	const setSelected = (root, value) => {
		const nativeSelect = root.querySelector('.custom-select__native');
		const valueEl = root.querySelector('.custom-select__value');
		const options = root.querySelectorAll('.custom-select__option');
		let selectedLabel = '';

		options.forEach((option) => {
			const isSelected = option.dataset.value === value;
			option.classList.toggle('custom-select__option--selected', isSelected);
			option.setAttribute('aria-selected', isSelected ? 'true' : 'false');

			if (isSelected) {
				selectedLabel = option.textContent.trim();
			}
		});

		if (nativeSelect) {
			nativeSelect.value = value;
		}

		if (valueEl && selectedLabel) {
			valueEl.textContent = selectedLabel;
		}

		root.dispatchEvent(
			new CustomEvent('custom-select:change', {
				bubbles: true,
				detail: {
					value,
					label: selectedLabel,
				},
			})
		);
	};

	const openSelect = (root) => {
		closeAllExcept(root);
		root.classList.add(OPEN_CLASS);

		const trigger = root.querySelector('.custom-select__trigger');
		if (trigger) {
			trigger.setAttribute('aria-expanded', 'true');
		}
	};

	const toggleSelect = (root) => {
		if (root.dataset.disabled === 'true') {
			return;
		}

		if (root.classList.contains(OPEN_CLASS)) {
			closeSelect(root);
			return;
		}

		openSelect(root);
	};

	const focusOptionByIndex = (root, index) => {
		const options = getFocusableOptions(root);
		if (!options.length) {
			return;
		}

		const normalizedIndex = (index + options.length) % options.length;
		options[normalizedIndex].focus();
	};

	const initCustomSelect = (root) => {
		if (!root || root.dataset.customSelectInit === 'true') {
			return;
		}

		root.dataset.customSelectInit = 'true';

		if (root.dataset.disabled === 'true') {
			root.classList.add('custom-select--disabled');
		}

		const trigger = root.querySelector('.custom-select__trigger');
		const nativeSelect = root.querySelector('.custom-select__native');
		const options = root.querySelectorAll('.custom-select__option');

		if (!trigger) {
			return;
		}

		trigger.addEventListener('click', () => {
			toggleSelect(root);
		});

		options.forEach((option) => {
			option.addEventListener('click', () => {
				if (option.disabled) {
					return;
				}

				setSelected(root, option.dataset.value || '');
				closeSelect(root);
				trigger.focus();
			});
		});

		if (nativeSelect) {
			nativeSelect.addEventListener('change', () => {
				setSelected(root, nativeSelect.value);
			});
		}

		root.addEventListener('keydown', (event) => {
			if (root.dataset.disabled === 'true') {
				return;
			}

			const isOpen = root.classList.contains(OPEN_CLASS);
			const focusableOptions = getFocusableOptions(root);
			const activeIndex = focusableOptions.indexOf(document.activeElement);

			switch (event.key) {
				case 'ArrowDown':
					event.preventDefault();
					if (!isOpen) {
						openSelect(root);
						focusOptionByIndex(root, 0);
					} else {
						focusOptionByIndex(root, activeIndex + 1);
					}
					break;
				case 'ArrowUp':
					event.preventDefault();
					if (!isOpen) {
						openSelect(root);
						focusOptionByIndex(root, focusableOptions.length - 1);
					} else {
						focusOptionByIndex(root, activeIndex - 1);
					}
					break;
				case 'Enter':
				case ' ':
					if (document.activeElement === trigger) {
						event.preventDefault();
						toggleSelect(root);
					}
					break;
				case 'Escape':
					if (isOpen) {
						event.preventDefault();
						closeSelect(root);
						trigger.focus();
					}
					break;
				default:
					break;
			}
		});
	};

	const initCustomSelects = (scope) => {
		const context = scope && scope.querySelectorAll ? scope : document;
		context.querySelectorAll('[data-custom-select]').forEach(initCustomSelect);
	};

	document.addEventListener('click', (event) => {
		if (event.target.closest('[data-custom-select]')) {
			return;
		}

		closeAllExcept(null);
	});

	document.addEventListener('DOMContentLoaded', () => {
		initCustomSelects(document);
	});

	window.initCustomSelects = initCustomSelects;
})();
